
import { Component, Vue } from 'vue-property-decorator'

/**
 * 文字列を表示するdiv要素のエリア
 */
@Component
export default class TextFrame extends Vue {}
